export function loadComponent(selector, initFunction) {
  if (document.querySelector(selector)) {
    initFunction();
  }
}